import { render } from "./ViewTab.vue?vue&type=template&id=44bb4012&scoped=true"
import script from "./ViewTab.vue?vue&type=script&lang=js"
export * from "./ViewTab.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-44bb4012"

export default script